import {getCachedTableStateSlice} from 'src/hooks/common-data-service/cached-table';

import type {CachedTableStateSelector} from 'src/hooks/common-data-service/cached-table/typedef';

export const userRoleAuditLogStateSlice = getCachedTableStateSlice<
    undefined,
    undefined,
    undefined
>('userRoleAuditLogState', undefined, {pageSize: 25, currentPage: 1});

export const userRoleAuditLogStateActions = userRoleAuditLogStateSlice.actions;
export const userRoleAuditLogStateSelector:
CachedTableStateSelector<undefined, undefined, undefined>
    = state => state.userPage.tabs.userRoleAuditLog.state;

